<div class="jira_integration">
    <div class="jira_integration_top">
        <div class="top_left">
            <div class="top_left_logo">
                <img src="../../../assets/images/slack.png">
            </div>
            <div class="top_left_heading">
                Setting / Integration's
                <p>Manage Integration's</p>
            </div>

        </div>
        <div class="top_right">
            <div class="top_right_logo">
                <a (click)="navigatePreviousUrl()">
                    <span class="close-icon" matTooltip="close" uk-icon="close"></span>
                </a>
            </div>
            <div class="top_right_content">
                <div class="top_right_heading">
                    <span class="material-symbols-outlined">
                        play_circle
                    </span>
                    Installation Guide
                </div>
                <span class="material-symbols-outlined">
                    more_horiz
                </span>
            </div>
        </div>
    </div>
    <div class="jira_integration_middle">
        <div class="middle_left">
            <img src="../../../assets/images/back2.jpg">
        </div>
        <div *ngIf="!isSlackIntegrationExists" class="middle_right">
            <h3>Welcome to {{brand.brandName}} Integration's for Slack!</h3>
            <p>You have no integration yet.<br>
                Add an integration to get started.</p>
            <button href="javascript:void(0)" (click)="integrateSlack()"><a>Add
                    Integration</a></button>
        </div>
        <div *ngIf="isSlackIntegrationExists" class="middle_right">
            <h3>Integration Successful!</h3>
            <p>Your {{brand.brandName}} integration is now <span>Active</span> with {{myData.length}} workspaces.
                <br> Begin your workflow or integrate more as needed.
            </p>
            <button href="javascript:void(0)" (click)="integrateSlack()"><a>Add
                    Workspace</a></button>
        </div>
    </div>
    <div class="jira_integration_bottom">
        <button>
            Get Integration Support
        </button>
    </div>
</div>
<div class="workspace-page" *ngIf="isSlackIntegrationExists">
    <p class="head">Workspace List ( {{myData.length}} )</p>
    <div class="workspace-grid">
        <div class="workspace-card" *ngFor="let workspace of myData">
            <div class="workspace-header">
                <!-- <img src="assets/slack-logo.png" alt="Slack Logo" class="slack-logo" /> -->
                <div class="workspace-info">
                    <h3>{{ workspace.team_name }}</h3>
                    <p>Team ID: {{ workspace.team_id }}</p>
                </div>
            </div>
            <div class="workspace-actions">
                <button class="disconnect-btn">Disconnect</button>
            </div>
        </div>
    </div>
</div>